import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const Inv2215SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    status: z.number().optional(),
    filterStatus: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv2215SearchParams = z.infer<typeof Inv2215SearchParamsSchema>

export const Inv2215SearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  date: z.coerce.date(),
  partyId: z.number().nullable(),
  refNo: z.string().nullable(),
  refDate: z.coerce.date().nullable(),
  remark: z.string().nullable(),
  status: z.union([z.literal(1), z.literal(2), z.literal(3), z.literal(4)]),
  isFulfilled: z.boolean().nullish(),
  confirmed: z.boolean().nullish(),
})

export type Inv2215SearchResultModel = z.infer<
  typeof Inv2215SearchResultModelSchema
>

export const Inv2215SearchResultSchema = z
  .object({
    data: z.array(Inv2215SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Inv2215SearchResult = z.infer<typeof Inv2215SearchResultSchema>

export const Inv2215ItemManualPickSchema = z.object({
  id: z.number(),
  itemId: z.number(),
  itemCode: z.string(),
  itemName: z.string(),
  lotNo: z.string(),
  mold: z.string(),
  lotDate: z.coerce.date(),
  isClaimItem: z.boolean(),
  availableQty: z.number(),
  location: z.string(),
})
export type Inv2215Inv2215ItemManualPick = z.infer<
  typeof Inv2215ItemManualPickSchema
>

export const Inv2215ManualPickResultSchema = z
  .object({
    data: z.array(Inv2215ItemManualPickSchema),
  })
  .merge(BasePaginateResultSchema)
export type Inv2215ManualPickResult = z.infer<
  typeof Inv2215ManualPickResultSchema
>
